// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
// define a new console
import Vue from 'vue'

import App from './App'
import AppF7 from './App_f7'

import router from './router'
import routerf7 from './routerf7'

import Framework7 from 'framework7'
import Framework7Vue from 'framework7-vue'

import VueClip from 'vue-clip'

/* import Framework7Theme from 'framework7/dist/css/framework7.ios.min.css'
import Framework7ThemeColors from 'framework7/dist/css/framework7.ios.colors.min.css' */

import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import Settings from './settings'

import tr from './translations/tr.json'
import en from './translations/en.json'
import de from './translations/de.json'
import et from './translations/et.json'
import da from './translations/da.json'
import nl from './translations/nl.json'
import sv from './translations/sv.json'
import he from './translations/he.json'
import es from './translations/es.json'
import ru from './translations/ru.json'
import ar from './translations/ar.json'
import no from './translations/no.json'
import hr from './translations/hr.json'

/*
// Create the div element
var overlayDiv = document.createElement('div')

// Apply necessary CSS styles
overlayDiv.style.position = 'absolute'
overlayDiv.style.top = '0'
overlayDiv.style.left = '0'
overlayDiv.style.width = '100%'
overlayDiv.style.height = '100%'
overlayDiv.style.backgroundColor = 'transparent'
overlayDiv.style.zIndex = '9999' // Adjust the z-index value as needed

// Append the div to the document body
document.body.appendChild(overlayDiv)

var console = (function (oldCons) {
  return {
    log: function () {
      // oldCons.log.apply(this, arguments)
      overlayDiv.innerHTML = '<span style="color:black; background-color:white">' + Array.prototype.join.call(arguments, ' ') + '</span><br>' + overlayDiv.innerHTML
    },
    dir: function () {
      overlayDiv.innerHTML = '<span style="color:black; background-color:white">' + Array.prototype.join.call(arguments, ' ') + '</span><br>' + overlayDiv.innerHTML
    },
    info: function () {
      // oldCons.info.apply(this, arguments)
      overlayDiv.innerHTML = '<span style="color:blue; background-color:white">' + Array.prototype.join.call(arguments, ' ') + '</span><br>' + overlayDiv.innerHTML
    },
    warn: function () {
      // oldCons.warn.apply(this, arguments)
      overlayDiv.innerHTML = '<span style="color:orange; background-color:white">' + Array.prototype.join.call(arguments, ' ') + '</span><br>' + overlayDiv.innerHTML
    },
    error: function () {
      // oldCons.error.apply(this, arguments)
      overlayDiv.innerHTML = '<span style="color:red; background-color:white">' + Array.prototype.join.call(arguments, ' ') + '</span><br>' + overlayDiv.innerHTML
    }
  }
})(window.console)

// Then redefine the old console
window.console = console

window.onerror = function (message, source, lineno, colno, error) {
  // Your custom error handling logic here
  // For example, log the error message to a specific element on the page
  overlayDiv.innerHTML = '<span style="color:red; background-color:white">' + message + '</span><br>' + overlayDiv.innerHTML
  // Return true to prevent the error from being displayed in the console
  return true
}
*/

console.log('Lang from LS: ' + localStorage.getItem('Language'))

var lang = localStorage.getItem('Language') || 'en'

console.log('Lang decided: ' + lang)

const messages = {
  tr,
  en,
  de,
  et,
  da,
  nl,
  sv,
  he,
  hr,
  es,
  ru,
  ar,
  no
}

Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
  fallbackLocale: 'en'
})

Vue.use(VueResource)
Vue.use(VueClip)

// https://github.com/pagekit/vue-resource/blob/1.3.4/docs/http.md#interceptors

Vue.http.interceptors.push(function (request, next) {
  var ls = location.search
  var bypass = ls.substr(ls.indexOf('bypass') + 7, 52)
  // modify method
  if (request.method === 'GET') { // those headers should be allowed in backend if CORS is used
    request.headers.set('Cache-Control', 'no-cache')
    request.headers.set('Pragma', 'no-cache')
    request.headers.set('Expires', 'Thu, 01 Jan 1970 00:00:00 GMT')
    request.headers.set('If-Modified-Since', '0')
  }

  if (request.method === 'GET' || request.method === 'POST' || request.method === 'PUT' || request.method === 'DELETE') {
    if (!request.headers.get('Authorization')) {
      var user = localStorage.getItem('user') || '{ "auth": "Og==" }'
      var authdetail = bypass || JSON.parse(user).auth
      request.headers.set('Authorization', 'Basic ' + authdetail)
    }
  }
  // continue to next interceptor
  next()
})

const vVisible = {
  install (Vue) {
    Vue.directive('visible', (el, binding) => {
      var value = binding.value

      if (value) {
        el.style.visibility = 'visible'
      } else {
        el.style.visibility = 'hidden'
      }
    })
  }
}

Vue.use(vVisible)

Vue.config.productionTip = false // https://vuejs-templates.github.io/webpack/env.html // https://vuejs-templates.github.io/webpack/env.html

if (process.env.NODE_ENV === 'production') {
  // console.log = function () {}
}

var VueInstance

if (document.getElementById('app')) {
  // require('reset-css/reset.css')
  console.log('Type of page: <div id="app"> (index.html or print.html)')

  VueInstance = new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
    i18n
  })
} else if (document.getElementById('app_f7')) {
  // require('framework7/dist/css/framework7.ios.min.css')
  // require('framework7/dist/css/framework7.ios.colors.min.css')
  console.log('Type of page: <div id="app_f7"> (index_f7.html)')

  Vue.use(Framework7Vue)

  VueInstance = new Vue({
    el: '#app_f7',
    template: '<app/>',
    // Init Framework7 by passing parameters here
    framework7: {
      root: '#app_f7',
      pushState: true,
      popupCloseByOutside: false,
      /* Uncomment to enable Material theme: */
      material: false,
      routes: routerf7
    },
    // Register App Component
    components: {
      app: AppF7
    },
    i18n
  })
} else {
  console.log('Type of page is INVALID')
}

const apiurl = 'http://' + Settings.host + ':6161/api'

VueInstance.$http.get(apiurl + '/config').then(response => {
  var cfg = response.body
  if (cfg.Language !== lang) {
    // Vue.prototype.$deviceConfig = 'My App'
    localStorage.setItem('Language', cfg.Language)
    VueInstance.$i18n.locale = cfg.Language
  }
}, response => {
  console.log('Error fetching config')
  console.dir(response)
})



// WEBPACK FOOTER //
// ./src/main.js